export default "__VITE_ASSET__CmgJQjW7__"